document.addEventListener('DOMContentLoaded', function () {
  var channel = 'https://www.youtube.com/channel/UCKixxdkUX7Qeh6fXSq6PEbA';

  document.querySelectorAll('a, button').forEach(function (el) {
    var label = (el.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
    if (label === 'BUILD YOUR BUNDLE' && !el.parentNode.querySelector('.bgc-bundle-roll-note')) {
      var note = document.createElement('div');
      note.className = 'bgc-bundle-roll-note';
      note.textContent = 'Watch those bundler discounts roll in.';
      note.style.cssText = 'font-size:13px;line-height:1.35;text-align:center;font-style:italic;color:#6F7B32;margin:8px auto 4px;max-width:230px';
      el.insertAdjacentElement('afterend', note);
    }
  });

  var customers = document.querySelector('.bgc-customers');
  if (customers) {
    var old = document.querySelector('.bgc-video-strip');
    if (old) old.remove();
    var strip = document.createElement('section');
    strip.className = 'bgc-video-strip';
    strip.setAttribute('aria-label', 'Discover Brazilian Gold Coffee');
    strip.innerHTML = '<div class="bgc-video-strip__inner">' +
      '<div class="bgc-video-strip__intro"><span>PEOPLE • BRAZIL • COFFEE</span><h3>DISCOVER BRAZILIAN GOLD COFFEE</h3><p>Meet the farmers, artists and people behind Brazilian Gold Coffee.</p></div>' +
      '<a class="bgc-video-card" href="https://www.youtube.com/channel/UCKixxdkUX7Qeh6fXSq6PEbA/search?query=Lais" target="_blank" rel="noopener"><span class="bgc-video-card__poster bgc-video-card__poster--artist"><span class="bgc-video-card__poster-kicker">ART • PEOPLE • BRAZIL</span><span class="bgc-video-card__poster-title">LAÍS</span></span><span class="bgc-video-card__shade"></span><span class="bgc-video-card__play">▶</span><span class="bgc-video-card__label">OUR AMAZING ARTIST, LAÍS — ENGLISH</span></a>' +
      '<a class="bgc-video-card" href="https://www.youtube.com/channel/UCKixxdkUX7Qeh6fXSq6PEbA/search?query=Faleiros" target="_blank" rel="noopener"><span class="bgc-video-card__poster bgc-video-card__poster--farmer"><span class="bgc-video-card__poster-kicker">FARMERS • SPECIALTY COFFEE</span><span class="bgc-video-card__poster-title">FALEIROS</span></span><span class="bgc-video-card__shade"></span><span class="bgc-video-card__play">▶</span><span class="bgc-video-card__label">FALEIROS — EL DORADO FARM</span></a>' +
      '<a class="bgc-video-card" href="/pages/copia-our-story#bgc-farmer-videos"><span class="bgc-video-card__poster bgc-video-card__poster--brazil"><span class="bgc-video-card__poster-kicker">LAND • FAMILIES • COFFEE</span><span class="bgc-video-card__poster-title">BRAZIL</span></span><span class="bgc-video-card__shade"></span><span class="bgc-video-card__play">▶</span><span class="bgc-video-card__label">MEET OUR BRAZILIAN FARMERS</span></a>' +
      '<a class="bgc-video-card" href="https://youtu.be/64E8QaAyb_4" target="_blank" rel="noopener"><span class="bgc-video-card__poster bgc-video-card__poster--brazil"><span class="bgc-video-card__poster-kicker">COFFEE • BREWING • BRAZIL</span><span class="bgc-video-card__poster-title">FELIPE</span></span><span class="bgc-video-card__shade"></span><span class="bgc-video-card__play">▶</span><span class="bgc-video-card__label">INVERTED AEROPRESS</span></a></div>';
    customers.parentNode.insertBefore(strip, customers);
  }

  if (window.location.pathname.indexOf('/pages/copia-our-story') !== -1) {
    var farmerImage = 'https://cdn.shopify.com/s/files/1/0412/3289/2055/files/storyphotos_ourfarmers.jpg';
    var existing = document.querySelector('.bgc-story-videos');
    if (existing) existing.remove();
    var storyImages = document.querySelectorAll('.wrap-the-row .row-col.is-two.img');
    if (storyImages.length) {
      var target = storyImages[storyImages.length - 1];
      var story = document.createElement('div');
      story.className = 'bgc-story-videos';
      story.id = 'bgc-farmer-videos';
      var cards = [
        ['VINHAL FAMILY — FAZENDA RECANTO','Vinhal',farmerImage],
        ['FALEIROS','Faleiros',farmerImage],
        ['TIAGO ALVES','Tiago%20Alves',farmerImage],
        ['FARMERS: LIGHT ROAST VS. DARK ROAST','light%20roast%20dark%20roast',farmerImage]
      ];
      story.innerHTML = '<div class="bgc-story-videos__eyebrow">MEET THE PEOPLE BEHIND THE COFFEE</div><h3>GET TO KNOW OUR FARMERS</h3><p>Meet some of the Brazilian specialty coffee farmers behind the coffees we love. Discover their farms, their families, and the people whose work begins every cup of Brazilian Gold Coffee.</p><div class="bgc-story-videos__grid">' +
        cards.map(function(c){return '<a class="bgc-story-videos__thumb" href="https://www.youtube.com/channel/UCKixxdkUX7Qeh6fXSq6PEbA/search?query='+c[1]+'" target="_blank" rel="noopener" aria-label="'+c[0]+'"><img src="'+c[2]+'" alt="'+c[0]+'"><span>'+c[0]+'</span></a>';}).join('') +
        '</div><a class="bgc-story-videos__cta" href="/pages/making-your-coffee">WAYS WE BREW COFFEE →</a>';
      target.appendChild(story);
    }
  }
  function addBrewButton(container, label, url) {
    if (!container || container.querySelector('a[data-bgc-brew="'+label+'"]')) return;
    var a = document.createElement('a');
    a.setAttribute('data-bgc-brew', label);
    a.href = url; a.target = '_blank'; a.rel = 'noopener';
    a.textContent = label + ' ▶';
    a.style.cssText = 'display:inline-block;margin:10px 4px 4px;padding:10px 14px;background:#D99B32;color:#351814!important;text-decoration:none!important;font-weight:700;border-radius:3px;font-size:12px;line-height:1.25';
    container.appendChild(a);
  }
  if (window.location.pathname.indexOf('/pages/individual-coffee-methods') !== -1) {
    var cols = document.querySelectorAll('.wrap-column');
    if (cols[0]) addBrewButton(cols[0], 'WATCH OUR ESPRESSO VIDEO', 'https://youtu.be/liqvOQpJI98');
  }
  if (window.location.pathname.indexOf('/pages/french-press') !== -1) {
    var fp = document.querySelectorAll('.wrap-column');
    if (fp[0]) addBrewButton(fp[0], 'WATCH OUR FRENCH PRESS VIDEO', 'https://youtu.be/BQ2a96cyxCI');
    if (fp[1]) addBrewButton(fp[1], 'WATCH AEROPRESS VIDEO 1', 'https://youtu.be/olnH2V-4J7Q');
    if (fp[2]) addBrewButton(fp[2], 'WATCH FELIPE — INVERTED AEROPRESS', 'https://youtu.be/64E8QaAyb_4');
  }
  if (window.location.pathname.indexOf('/pages/pour-overs') !== -1) {
    var po = document.querySelectorAll('.wrap-column');
    if (po[0]) addBrewButton(po[0], 'WATCH OUR POUR-OVER VIDEO', 'https://youtu.be/5i9GFwiUTOY');
  }

  if (window.location.pathname === '/pages/coffee-subscription') {
    setTimeout(function () {
      var intro = document.querySelector('.bgc-subscription-intro p');
      if (intro) {
        intro.textContent = 'Choose your Brazilian Gold Coffee, select your delivery rhythm, and use Subscribe & Save for recurring delivery. Your actual Shopify subscription plan is added to the cart.';
      }
      var shell = document.querySelector('.bgc-subscription-shell');
      if (shell) {
        shell.style.backgroundImage = "linear-gradient(135deg,rgba(255,253,248,.94),rgba(247,239,225,.94),rgba(238,242,223,.94)),url('https://cdn.shopify.com/s/files/1/0412/3289/2055/files/bgc-subscription-toucan-2026.png?v=1789158149')";
        shell.style.backgroundRepeat = 'no-repeat';
        shell.style.backgroundPosition = 'left 110px';
        shell.style.backgroundSize = '130px auto';
        var grid = shell.querySelector('.bgc-subscription-grid');
        if (grid && !shell.querySelector('.bgc-subscription-footer')) {
          var footer = document.createElement('div');
          footer.className = 'bgc-subscription-footer';
          footer.innerHTML = '<h2>NEVER RUN OUT OF BRAZILIAN GOLD COFFEE!</h2><p>WHY WOULD YOU WANT TO DO THAT TO YOURSELF?</p>';
          footer.style.cssText = 'text-align:center;margin:42px auto 0;padding:28px 18px;border-top:1px solid #E7E1D8;max-width:900px';
          var h = footer.querySelector('h2'); h.style.cssText='color:#6F7B32!important;font-size:30px!important;margin:0 0 8px';
          var p = footer.querySelector('p'); p.style.cssText='color:#A8342F!important;font-weight:700;letter-spacing:1px;margin:0';
          grid.insertAdjacentElement('afterend', footer);
        }
      }
      var all = document.querySelectorAll('#content_wrapper h2, #content_wrapper p');
      all.forEach(function(el){
        var t=(el.textContent||'').trim();
        if (t === 'Choose your favorite coffee and select the available subscription option on the product page for recurring delivery.' ||
            t === 'Bossa Nova Ipanema Samba Decaf Tropicália') el.remove();
      });
    }, 300);
  }

});

/* BGC wholesale route repair — Sep 16, 2026.
   Theme-local and intentionally narrow: only links that still point to the retired
   /wholesale or /pages/wholesale route are changed. Existing logged-in wholesale
   collection logic and all cart/checkout code remain untouched. */
(function () {
  var bgcWholesaleRegister = '/pages/wholesale-register';

  function normalizeWholesalePath(href) {
    if (!href) return '';
    try {
      var url = new URL(href, window.location.origin);
      return (url.pathname || '').replace(/\/+$/, '').toLowerCase();
    } catch (e) {
      return String(href).split('#')[0].split('?')[0].replace(/\/+$/, '').toLowerCase();
    }
  }

  function fixOldWholesaleLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('a[href]').forEach(function (a) {
      var path = normalizeWholesalePath(a.getAttribute('href'));
      if (path === '/wholesale' || path === '/pages/wholesale') {
        a.setAttribute('href', bgcWholesaleRegister);
      }
    });
  }

  function runWholesaleRouteFix() {
    fixOldWholesaleLinks(document);
    window.setTimeout(function () { fixOldWholesaleLinks(document); }, 250);
    window.setTimeout(function () { fixOldWholesaleLinks(document); }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runWholesaleRouteFix, { once: true });
  } else {
    runWholesaleRouteFix();
  }

  document.addEventListener('shopify:section:load', function (event) {
    fixOldWholesaleLinks(event.target || document);
  });
})();